<template>
  <div class="adm-tabs" role="tablist" :aria-label="label">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      type="button"
      role="tab"
      class="adm-tabs__tab"
      :class="{ 'is-active': tab.value === modelValue }"
      :aria-selected="tab.value === modelValue"
      @click="$emit('update:modelValue', tab.value)"
    >
      <component v-if="tab.icon" :is="tab.icon" :size="16" />
      {{ tab.label }}
    </button>
  </div>
</template>

<script>
/**
 * Pestañas internas de una vista — plan 27_09_2026 §4.2.
 *
 * Sustituye a los grupos de botones que Gastos, Ingresos y Dashboard usaban
 * para cambiar de sub-vista (`.button--active`, `.pill.active`): eran botones
 * normales con una clase extra, sin semántica de pestaña ni `aria-selected`.
 *
 * tabs: [{ value, label, icon? }]
 */
export default {
  name: 'AdmTabs',
  props: {
    modelValue: { type: [String, Number], required: true },
    tabs: { type: Array, required: true },
    label: { type: String, default: 'Secciones' },
  },
  emits: ['update:modelValue'],
};
</script>

<style scoped>
.adm-tabs {
  display: flex;
  gap: 0.25rem;
  flex-wrap: wrap;
  padding: 0.25rem;
  background-color: var(--adm-surface-alt);
  border: 1px solid var(--adm-border);
  border-radius: var(--adm-radius);
  width: fit-content;
  max-width: 100%;
}

.adm-tabs__tab {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.85rem;
  background: none;
  border: none;
  border-radius: var(--adm-radius-sm);
  color: var(--color-text);
  font-family: var(--font-body);
  font-size: var(--adm-font-sm);
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.adm-tabs__tab:hover { color: var(--color-title); }

.adm-tabs__tab.is-active {
  background-color: var(--adm-surface);
  color: var(--color-brand);
  font-weight: 600;
  box-shadow: var(--adm-shadow);
}
</style>
